var searchPage = {
    type: 1,
    keyword: '',
    articlePageInfo: {
        page: 1
    },
    projectPageInfo: {
        page: 1
    },
    init: function () {
        searchPage.keyword = UTL.getSearchParam("keyword") || '';
        searchPage.type = UTL.getSearchParam("type") || 1;
        searchPage.switchTab(searchPage.type);
        searchPage.handleSearch();
        if (searchPage.keyword) {
            searchPage.getResult({
                page: 1,
                type: searchPage.type,
                keyword: searchPage.keyword,
                articleCb: searchPage.renderArticleList,
                projectCb: searchPage.renderProjectList
            });
            searchPage.loadMore();
        } else {
            $("#artciles_field").append('<div class="empty-project">该关键字没有相关文章，请输入其他关键字查询</div>');
            $("#projects_field ul").append('<li class="empty-project">该关键字没有相关项目，请输入其他关键字查询</li>');
            searchPage.fetchProjectStatus('hide');
            searchPage.fetchArticleStatus('hide');
        }

    },
    handleSearch: function () {
        $('#searchInputDom input').val(UTL.getSearchParam("keyword"));
        $('#searchInputDom input').focus();

        $('#searchInputDom .search-btn').on('click', function (e) {
            var keyword = $("#searchInputDom input").val().trim();
            keyword = keyword.replace(/\%/g, "%25");
            keyword = keyword.replace(/\#/g, "%23");
            keyword = keyword.replace(/\&/g, "%26");
            var url = `/searchresult?keyword=${keyword}&type=${searchPage.type}`
            if (keyword) {
                window.location.href = url;
            }
        })
        $('#searchInputDom input').on('keyup', function (e) {
            if (e.keyCode == "13") {
                var keyword = $("#searchInputDom input").val().trim();
                keyword = keyword.replace(/\%/g, "%25");
                keyword = keyword.replace(/\#/g, "%23");
                keyword = keyword.replace(/\&/g, "%26");
                var url = `/searchresult?keyword=${keyword}&type=${searchPage.type}`
                if (keyword) {
                    window.location.href = url;
                }
            }
        })
    },
    getResult: function (options) {
        UTL.ajax({
            url: v1url + "search/pc-list",
            type: "GET",
            data: {
                page: options.page,
                type: options.type,
                keyword: options.keyword
            },
            success: function (data) {
                if ((typeof data) == "string") {
                    data = $.parseJSON(data);
                }
                options.articleCb && options.articleCb(data.data.article);
                options.projectCb && options.projectCb(data.data.project);
            }
        });
    },
    renderProjectList: function (data) {
        if (!data.list || data.list.length == 0) {
            $("#projects_field ul").append('<li class="empty-project">该关键字没有相关项目，请输入其他关键字查询</li>');
            searchPage.fetchProjectStatus('hide');
            return;
        }
        var items = data.list;
        if (items.length < 10) {
            searchPage.fetchProjectStatus('nomore');
        } else {
            searchPage.fetchProjectStatus('getmore');
        }
        searchPage.projectPageInfo = data.page_info;
        $('#projectCount').text(data.page_info.total);
        var i = 0,
            len = items.length;
        var _html = "";
        for (; i < len; i++) {
            var item = items[i];
            _html += `<li class="project-item">
        <div class="img-info">
            <div class="img-wrap">
            <img src=${
                item.logo_url
                    ? `${item.logo_url}`
                    : "/imgs/pay/common/bird.png"
                } alt="">
            </div>
            ${item.is_round == 1 ? '<p class="round-status">正在融资</p>' : ""}
        </div>
        <div class="project-info">
            <div class="project-base-info">
                <div class="col-item col-1">
                    <div class="base-info">
                        <div class="project-name">
                            <div class="name"><a target="_blank" href="/projectdetail/${
                item.id
                }?from=search_project_list">${item.name}</a></div>
                            ${
                item.is_publish == 1
                    ? ' <div class="pencilnews-report">优选项目</div>'
                    : ""
                }
                        </div>
                        <div class="introduce">${
                item.introduce ? item.introduce : ""
                }</div>
                    </div>
                </div>
                <div class="col-item col-2 industry">
                ${item.industry[0] ? `<p>${item.industry[0]}</p>` : ""}
                
                </div>
                <div class="col-item col-3 address">${
                item.province ? item.province : '暂无'
                }</div>
                <div class="col-item col-4 round">${
                item.stage_name ? item.stage_name : ""
                }</div>
                <div class="col-item col-5 creact-at">${
                item.publish_time ? item.publish_time.split(" ")[0] : ""
                }</div>
            </div>
            ${
                item.bright_label_string
                    ? `<div class="tag" id="label-string">${
                    item.bright_label_string
                    }</div>`
                    : ""
                }
        </div>
    </li>`;
        }
        $("#projects_field ul").append(_html);
    },
    renderArticleList: function (data) {
        if (!data.list || data.list.length == 0) {
            $("#artciles_field").append('<div class="empty-project">该关键字没有相关文章，请输入其他关键字查询</div>');
            searchPage.fetchArticleStatus('hide');
            return;
        }
        var res = data.list;
        searchPage.articlePageInfo = data.page_info;
        $('#articleCount').text(data.page_info.total);
        if (res.length < 10) {
            searchPage.fetchArticleStatus('nomore');
        } else {
            searchPage.fetchArticleStatus('getmore');
        }
        var artcilesListHTML = "";
        for (i = 0; i < res.length; i++) {
            var article = res[i];
            var articleId = article.article_id;
            var articleUrl = "/p/" + articleId + ".html";
            var coverImg = article.cover_img;
            coverImg = (coverImg == '无图片' ? 'library/1/ecd168d5aa78b313c74edfbaf24943d7.png' : coverImg)
            var coverUrl = imgUrl + coverImg + imageview1x;
            var artcileTitle = article.title

            var cateId = article.cate_id;

            var cateName = article.cate_name;
            var articleDigest = article.body;

            var authorId = article.uid;
            var authorName = article.name;
            var createAt = article.create_at;
            var deaufalt_img = "'/imgs/qianbidao.png'";

            createAt = timeFormatConvert(createAt);
            artcilesListHTML +=
                `<div class="article_block">
            <div class="article_img">
                <a href="${articleUrl}" target="_blank">
                  <img src="${coverUrl}" alt="${artcileTitle}" onerror="this.src=${deaufalt_img}">
                </a>
            </div>
            <div class="article_content">
                <h3><a href="${articleUrl}" target="_blank">${artcileTitle}</a></h3>
                <div class="article_digest">
                  <a href="${articleUrl}" target="_blank">
                    <span>${articleDigest}</span>
                  </a>
                </div>
                <div class="article_author">
                  <div>
                    <span class="cate-tag-${cateId} cate-tag">${cateName}</span>
                  </div>
                  <div class="author_items">
                        <a href="/journalist/${authorId}">
                          <span>${authorName}</span>
                        </a>
                        <span>${createAt}</span>
                      </div>
                  </div>
              </div>
        </div>`;
        }

        $('#artciles_field').append(artcilesListHTML);
    },
    switchTab: function (type) {
        if (type) {
            if (type == 2) {
                $('#searchTab .js-search-tab-project').addClass('active');
                $('#articles_list_container').addClass('hide');
                $('#projects_list_container').removeClass('hide');
            } else {
                $('#searchTab .js-search-tab-article').addClass('active');
                $('#articles_list_container').removeClass('hide');
                $('#projects_list_container').addClass('hide');
            }
        } else {
            $('#searchTab .js-search-tab-article').addClass('active');
            $('#articles_list_container').removeClass('hide');
            $('#projects_list_container').addClass('hide');
        }
        $('#searchTab .js-search-tab-article').on('click', function () {
            $(this).addClass('active').siblings().removeClass('active');
            $('#articles_list_container').removeClass('hide');
            $('#projects_list_container').addClass('hide');
            searchPage.type = 1;

        })
        $('#searchTab .js-search-tab-project').on('click', function () {
            $(this).addClass('active').siblings().removeClass('active');
            $('#articles_list_container').addClass('hide');
            $('#projects_list_container').removeClass('hide');
            searchPage.type = 2;
        })
    },
    loadMore: function () {
        $(".js_load_more_articles span").click(function () {
            searchPage.fetchArticleStatus('loading');
            searchPage.getResult({
                page: searchPage.articlePageInfo.page + 1,
                type: 1,
                keyword: searchPage.keyword,
                articleCb: searchPage.renderArticleList
            })
        });
        $(".js_load_more_projects span").click(function () {
            searchPage.fetchProjectStatus('loading');
            searchPage.getResult({
                page: searchPage.projectPageInfo.page + 1,
                type: 2,
                keyword: searchPage.keyword,
                projectCb: searchPage.renderProjectList
            })
        });

    },
    fetchArticleStatus: function (status) {
        if (status == 'loading') {
            $(".js_load_more_articles div").hide();
            $(".js_load_more_articles span").hide();
            $(".js_load_more_articles img").show();
        } else if (status == 'nomore') {
            $(".js_load_more_articles img").hide();
            $(".js_load_more_articles span").hide();
            $(".js_load_more_articles div").show();
        } else if (status == 'getmore') {
            $(".js_load_more_articles div").hide();
            $(".js_load_more_articles span").show();
            $(".js_load_more_articles img").hide();
        } else if (status == 'hide') {
            $(".js_load_more_articles").hide();
        }
        return;
    },
    fetchProjectStatus: function (status) {
        if (status == 'loading') {
            $(".js_load_more_projects div").hide();
            $(".js_load_more_projects span").hide();
            $(".js_load_more_projects img").show();
        } else if (status == 'nomore') {
            $(".js_load_more_projects img").hide();
            $(".js_load_more_projects span").hide();
            $(".js_load_more_projects div").show();
        } else if (status == 'getmore') {
            $(".js_load_more_projects div").hide();
            $(".js_load_more_projects span").show();
            $(".js_load_more_projects img").hide();
        } else if (status == 'hide') {
            $(".js_load_more_projects").hide();
        }
        return;
    },

}
